module.exports = __webpack_public_path__ + "static/giantBottle-60c191e8e8c4679beb7c37fbccc78dcb.jpg";